import type { Merchant, PartnerTypes } from './types';

// Minimal runtime guards for critical API response shapes. We don't validate
// every field — just enough to detect "API returned an error object" or
// "response shape drifted". Missing optional fields are tolerated.

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const isMerchant = (value: unknown): value is Merchant =>
  isRecord(value) &&
  typeof value.id === 'string' &&
  typeof value.name === 'string';

export const isMerchantArray = (value: unknown): value is Merchant[] =>
  Array.isArray(value) && value.every(isMerchant);

export const isPartnerTypes = (value: unknown): value is PartnerTypes =>
  isRecord(value) &&
  typeof value.id === 'string' &&
  typeof value.name === 'string';
